module.exports = __webpack_public_path__ + "img/index2.a9422978.png";